export default __webpack_public_path__ + "static/media/imgWater.23aed6a9.png";